import { IconSeparator } from '@tabler/icons-react'

import { DividerDisplayBlock as RenderDividerDisplayBlock } from '../../templateRenderer/DisplayBlocks/DividerDisplayBlock'
import { DividerDisplayBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  TypeOption,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<DividerDisplayBlock> {
  public override kind = 'display' as const
  public override type = 'divider' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Divider',
    icon: IconSeparator,
    helpText: 'Break up the content',
    hideName: true,
    hideDescription: true,
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = []

  public override mapFormValueToBlock(
    block: DividerDisplayBlock
  ): DividerDisplayBlock {
    return block
  }

  public override renderBlock(): React.ReactNode {
    return <RenderDividerDisplayBlock />
  }
}

export const DividerDisplayBlockConfig = new Config()
